import { UserI18NPort } from '../domains/User';

export class I18NApplication {
  private static instance: I18NApplication;

  public readonly userI18N: UserI18NPort;
  public readonly userI18NScopedTranslator: typeof UserI18NPort.scopedTranslator;

  public static getInstance(): I18NApplication {
    if (!I18NApplication.instance) {
      I18NApplication.instance = new I18NApplication();
    }
    return I18NApplication.instance;
  }

  private constructor() {
    this.userI18N = UserI18NPort.create();
    this.userI18NScopedTranslator = UserI18NPort.scopedTranslator;
  }
}
